"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAssemblyDevice = void 0;
const options_1 = __importDefault(require("../../data/options"));
const utils_1 = require("../../utils");
const generate_mnemonics_1 = require("../mnemonics/generate-mnemonics");
const utils_2 = require("../../utils");
const generateAssemblyDevice = (contactRefId, subsystem, childSubsystem, subsystemOptions) => {
    const name = (0, utils_1.shuffle)(options_1.default.assemblyDevices);
    const numOfMnemonics = subsystemOptions?.assemblyDeviceOptions?.mnemonicsPerAssemblyDevice || 1;
    const mnemonics = (0, generate_mnemonics_1.generateMnemonics)(numOfMnemonics, {
        contactRefId,
        subsystem,
        childSubsystem,
        assemblyDevice: name,
        ...subsystemOptions?.mnemonicOptions,
    });
    const status = (0, utils_2.getMostSevereStatus)(mnemonics);
    return {
        name,
        status: status,
        childSubsystemParent: childSubsystem,
        mnemonics: mnemonics,
    };
};
exports.generateAssemblyDevice = generateAssemblyDevice;
